// extracted by mini-css-extract-plugin
export var contrastLow = "_a-1";
export var externalLink = "_a-2";
export var externalLinkIcon = "_a-3";
export var link = "_a-0";
export var linkLabel = "_a-4";